import React, { createContext } from 'react';

import { IdentityProvider } from '../../context';

import { NewHDProvider } from '.';

export const NewHDContext = createContext(null);

export function NewHDComposer() {
  return (
    <IdentityProvider>
      <NewHDProvider />
    </IdentityProvider>
  );
}
